import type { NavItemsProps } from "@/components/Header/HeaderMenu/types/NavItemsProps";

export const navItemsIds = {
  inicio: "inicio",
  solucoes: "solucoes",
  nossasSolucoes: "nossas-solucoes",
  regimesQueAtendemos: "regimes-que-atendemos",
  ramosQueAtendemos: "ramos-que-atendemos",
  faleConosco: "fale-conosco",
  nossosNumeros: "nossos-numeros",
  depoimentos: "depoimentos",
  ondeEstamos: "onde-estamos",
  nossoContato: "nosso-contato",
  sejaRepresentante: "seja-representante",
};

export const navItems: NavItemsProps[] = [
  {
    id: navItemsIds.inicio,
    title: "Início",
    href: "/",
  },
  {
    id: navItemsIds.solucoes,
    title: "Soluções",
    href: "/",
    subMenu: [
      {
        id: navItemsIds.nossasSolucoes,
        title: "Nossas Soluções",
        href: "/",
      },
      {
        id: navItemsIds.regimesQueAtendemos,
        title: "Regimes",
        href: "/",
      },
      {
        id: navItemsIds.ramosQueAtendemos,
        title: "Ramos",
        href: "/",
      },
    ],
  },
  {
    id: navItemsIds.nossosNumeros,
    title: "Nossos Números",
    href: "/",
  },
  {
    id: navItemsIds.depoimentos,
    title: "Depoimentos",
    href: "/",
  },
  {
    id: navItemsIds.faleConosco,
    title: "Fale Conosco",
    href: "/",
    subMenu: [
      {
        id: navItemsIds.nossoContato,
        title: "Nosso Contato",
        href: "/",
      },
      {
        id: navItemsIds.sejaRepresentante,
        title: "Seja Representante",
        href: "/",
      },
    ],
  },
  {
    id: navItemsIds.ondeEstamos,
    title: "Onde Estamos?",
    href: "/",
  },
];
